import {Action} from '@financial/common-logs'

import {UiEvent, UiEventType} from './uiEventAction'

/**
 * 주문형 & 디컨 주문서 공통으로 적용되므로 libs 에서 관리
 * service, area, code 순
 * @see https://wiki.fin.navercorp.com/pages/viewpage.action?pageId=132737218
 */
export const AUTargetMap = new Map<UiEventType, {actionType: Action; value: [string, string, string]}>([
    [UiEvent.ENTER_ORDERSHEET, {actionType: Action.View, value: ['ord', 'A0', 'ent_orderenter']}],
    [UiEvent.EXPOSED_DELIVERY, {actionType: Action.View, value: ['ord', 'B0', 'imp_deli']}],
    [UiEvent.EXPOSED_PERSONAL_CUSTOMS_CLEARANCE, {actionType: Action.View, value: ['ord', 'C0', 'imp_customscode']}],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_REQUEST, {actionType: Action.Click, value: ['ord', 'C1', 'click_pccrequest']}],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_SAVE, {actionType: Action.Click, value: ['ord', 'C2', 'click_pccsave']}],
    [
        UiEvent.PERSONAL_CUSTOMS_CLEARANCE_OPEN_UNIPASS,
        {actionType: Action.Click, value: ['ord', 'C3', 'click_pccopenunipass']},
    ],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_CALL, {actionType: Action.Click, value: ['ord', 'C4', 'click_pcccall']}],
    [
        UiEvent.PERSONAL_CUSTOMS_CLEARANCE_AGREE_SAVE,
        {actionType: Action.Click, value: ['ord', 'C5', 'click_pccagreesave']},
    ],
    [UiEvent.PERSONAL_CUSTOMS_CLEARANCE_CONFIRM, {actionType: Action.Click, value: ['ord', 'C6', 'click_pccconfirm']}],
    [UiEvent.EXPOSED_PURCHASER, {actionType: Action.View, value: ['ord', 'D0', 'imp_buyer']}],
    [UiEvent.EXPOSED_PRODUCT, {actionType: Action.View, value: ['ord', 'E0', 'imp_prod']}],
    [UiEvent.EXPOSED_NOT_OPENED_POINT, {actionType: Action.View, value: ['ord', 'F1', 'imp_poimon_generaluser']}],
    [UiEvent.EXPOSED_OPENED_POINT, {actionType: Action.View, value: ['ord', 'F2', 'imp_poimon_hanauser']}],
    [UiEvent.EXPOSED_PAY_LATER_NOT_JOINED, {actionType: Action.View, value: ['ord', 'G1', 'imp_paylater_x']}],
    [UiEvent.EXPOSED_PAY_LATER_JOINED, {actionType: Action.View, value: ['ord', 'G2', 'imp_paylater_o']}],
    [UiEvent.EXPOSED_DISABLED_PAYMENT_METHOD, {actionType: Action.View, value: ['ord', 'H0', 'imp_paymethod_dim']}],
    [UiEvent.EXPOSED_RECHARGE_PAYMENT, {actionType: Action.View, value: ['ord', 'H0', 'imp_npaymoney_generaluser_o']}],
    [UiEvent.EXPOSED_PAYMONEY_PAYMENT, {actionType: Action.View, value: ['ord', 'H0', 'imp_npaymoney_hanauser_o']}],
    [UiEvent.EXPOSED_EASY_BANK_PAYMENT, {actionType: Action.View, value: ['ord', 'H0', 'imp_simpleaccount_o']}],
    [UiEvent.EXPOSED_EASY_CARD_PAYMENT, {actionType: Action.View, value: ['ord', 'H0', 'imp_simplecard_o']}],
    [UiEvent.EXPOSED_SAMSUNG_PAY_PAYMENT, {actionType: Action.View, value: ['ord', 'H0', 'imp_samsungpay_o']}],
    [UiEvent.EXPOSED_CREDIT_CARD_PAYMENT, {actionType: Action.View, value: ['ord', 'H0', 'imp_creditcard_o']}],
    [UiEvent.EXPOSED_MOBILE_PAYMENT, {actionType: Action.View, value: ['ord', 'H0', 'imp_cellphone_o']}],
    [UiEvent.EXPOSED_VIRTUAL_ACCOUNT, {actionType: Action.View, value: ['ord', 'H0', 'imp_deposit_o']}],
    [UiEvent.EXPOSED_VOUCHER_PAYMENT, {actionType: Action.View, value: ['ord', 'H0', 'imp_giftcard_o']}],
    [UiEvent.EXPOSED_TMONEY_PAYMENT, {actionType: Action.View, value: ['ord', 'H0', 'imp_tmoney_o']}],
    [UiEvent.EXPOSED_WELFARE_CARD_PAYMENT, {actionType: Action.View, value: ['ord', 'H0', 'imp_culturenuricard_o']}],
    [UiEvent.EXPOSED_PAY_PAL_PAYMENT, {actionType: Action.View, value: ['ord', 'H0', 'imp_paypal_o']}],
    [UiEvent.EXPOSED_CASH_RECEIPT, {actionType: Action.View, value: ['ord', 'M0', 'imp_receipt_cash']}],
    [UiEvent.EXPOSED_ORDER_DETAIL, {actionType: Action.View, value: ['ord', 'N0', 'imp_sum']}],
    [UiEvent.EXPOSED_ACCUMULATE_POINT, {actionType: Action.View, value: ['ord', 'O0', 'imp_benefit']}],
    [UiEvent.EXPOSED_SUBMIT_BUTTON, {actionType: Action.View, value: ['ord', 'P0', 'imp_pay']}],
    [UiEvent.SUBMIT_CLICK_BUTTON, {actionType: Action.Click, value: ['ord', 'P0', 'click_pay']}],
    [UiEvent.ENTER_ORDER_FAILURE, {actionType: Action.View, value: ['ord', 'Z0', 'ent_orderfail_loadfail']}],
    [UiEvent.ENTER_ORDER_APPLY_FAILURE, {actionType: Action.View, value: ['ord', 'Z0', 'ent_orderfail_processfail']}],
    [UiEvent.ENTER_ORDER_SUCCEED, {actionType: Action.View, value: ['ord', 'Z0', 'ent_orderdone']}],
])
